export default __webpack_public_path__ + "static/media/loading.db225f58.gif";